module.exports = __webpack_public_path__ + "static/media/2.a59e83aa.jpg";